module.exports = __webpack_public_path__ + "static/media/delete.f67c58b1.svg";